import ApiManager from '../../api/crud-manager';
import { formatNumber } from '../../utils/price/formatNumber';
import { formatPrice } from '../../utils/price/formatPrice';

class RealTimePriceStaffels {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="RealTimePriceStaffels"]'),
      staffelsModuleList: el =>
        el.querySelectorAll('[data-module="RealTimePriceStaffels_Staffel"]'),
      originalModule: el =>
        el.querySelector('[data-child-module="RealTimePriceStaffels_Original"]'),
      discountModule: el =>
        el.querySelector('[data-child-module="RealTimePriceStaffels_Discount"]'),
      currentModule: el => el.querySelector('[data-child-module="RealTimePriceStaffels_Current"]'),
      priceModule: el => el.querySelector('[data-price]'),
      errorModule: el => el.querySelector('[data-error]'),
      loaderModule: el => el.querySelector('[data-loading]'),
      apiManager: new ApiManager()
    };
  }

  async getPrice(productId, staffel) {
    return this.config.apiManager.get(
      `/api/v2/catalog/product/${productId}/prices?quantity=${staffel}&currency=EUR`
    );
  }

  async handleModulePriceCall(module, productId, price) {
    module.style.display = '';
    const { noPrices, noPricesAttribute } = module.dataset;
    const noPricesBool = noPrices.toLowerCase() === 'true';

    const {
      originalModule,
      discountModule,
      currentModule,
      priceModule,
      errorModule,
      loaderModule
    } = this.config;

    const showError = () => errorModule(module).classList.remove('hidden');
    const removeLoader = () => loaderModule(module).classList.remove('is-loading');

    removeLoader();

    if (price === null) {
      showError();
      return;
    }

    const { originalPrice, currentPrice } = price;
    const discountPercent = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);

    if (originalModule(module)) {
      priceModule(originalModule(module)).innerHTML = formatPrice(
        originalPrice,
        noPricesBool,
        noPricesAttribute.length > 0 ? Number(noPricesAttribute) : null
      );
    }

    if (discountModule(module)) {
      priceModule(discountModule(module)).innerHTML = `${
        noPricesBool ? 'XX' : formatNumber(discountPercent, 0)
      }%`;
    }

    if (currentModule(module)) {
      priceModule(currentModule(module)).innerHTML = formatPrice(
        currentPrice,
        noPricesBool,
        noPricesAttribute.length > 0 ? Number(noPricesAttribute) : null
      );
    }
  }

  async handleModuleProduct(module) {
    const { staffelsModuleList, loaderModule, errorModule } = this.config;
    const { initialized, productId, staffels } = module.dataset;

    if (initialized) return;

    module.dataset.initialized = true;

    const staffelsArray = staffels.split('#').map(x => this.getPrice(productId, x));
    const pricesResponse = await Promise.all(staffelsArray);

    if (pricesResponse.length === 0 || pricesResponse[0]._embedded.prices.length === 0) {
      staffelsModuleList(module).forEach(staffelModule => {
        loaderModule(staffelModule).classList.remove('is-loading');
        errorModule(staffelModule).classList.remove('hidden');
      });
      return;
    }

    const mappedPrices = pricesResponse
      .map(x => ({
        staffel: x._embedded.prices[0].quantity,
        price: x._embedded.prices[0]
      }))
      .sort((a, b) => a.staffel - b.staffel);

    const filteredPrices = mappedPrices.filter(
      (x, i, arr) => i === 0 || x.price.currentPrice !== arr[i - 1].price.currentPrice
    );

    staffelsModuleList(module).forEach(staffelModule => {
      const { staffel } = staffelModule.dataset;
      const numberStaffel = Number(staffel);

      if (filteredPrices.some(x => x.staffel === numberStaffel)) {
        const priceObj = filteredPrices.find(x => x.staffel === numberStaffel).price;
        this.handleModulePriceCall(staffelModule, productId, priceObj);
      }
    });
  }

  init() {
    this.config.moduleList().forEach(module => {
      this.handleModuleProduct(module);
    });
  }
}

export default RealTimePriceStaffels;
